import { useEffect, useState } from 'react'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import axios from 'axios'
import placeholder from '../../assets/images/img-placeholder.jpg'
import { useHistory } from 'react-router'

export const InventoryView = () => {
  const server = process.env.REACT_APP_SERVER_URL

  const [items, setItems] = useState<any[]>([])

  const [originalItems, setOriginalItems] = useState<any[]>([])

  const [loading, setLoading] = useState<boolean>(false)

  const history = useHistory()

  const [filterText, setFilterText] = useState<string>("")

  const getData = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${server}/inventory/item`)
      setItems(res.data.items)
      setOriginalItems(res?.data?.items)
    } catch (error: any) {
      console.log(error?.message)
    }
    setLoading(false)
  }

  useEffect(() => {
    getData()
  }, [])

  const onClickItem = (item: any) => {
    console.log('ITEM', item)
    history.push('/individualItem', item)
  }

  return (
    <div className="h-full">
      <div>
        <label className="font-medium">Tu inventario</label>
      </div>

      <div className="flex flex-row justify-end">
        <Button type="primary" classes="w-sm mr-4" htmlType="submit" onClick={() => history?.push("/warehouses", { type: 'load' })}>
          Cargar
        </Button>
        <Button
          type="outline"
          classes="w-sm mr-4"
          htmlType="button"
          onClick={() => history?.push("/warehouses", { type: 'unload' })}
        >
          Descargar
        </Button>
      </div>

      <div className="w-[60%] mt-5">
        <InputText placeholder="Buscar Artículo..." onChangeValue={(value) => {
            // setFilterText(value)

            const newData = originalItems?.filter(function (item) {
                // Applying filter for the inserted text in search bar
                const itemData = item.name
                  ? item.name.toUpperCase()
                  : ''.toUpperCase();
      
                const textData = value.toUpperCase();
      
                const itemBarcode = item?.sku
      
                const result = (itemData.indexOf(textData) > -1) || (itemBarcode ? itemBarcode?.indexOf(value) > -1 : null)
      
                return result;
              });

              setItems(newData)

        }}  />
      </div>

      <div className="flex justify-between">
        <div className="text-primary font-bold w-[70%]">Artículo</div>
        <div className="text-primary font-bold w-[20%]">Existencia</div>
      </div>

      <div>
        {items?.map((x) => (
          <div
            className="flex mt-3"
            style={{ lineBreak: 'anywhere' }}
            onClick={() => onClickItem(x)}
          >
            <div className=" w-[70%] flex items-center">
              {
                <img
                  src={x?.image || placeholder}
                  style={{ width: 40, height: 40, borderRadius: 6 }}
                  className="mr-4"
                />
              }

              {x?.name}
            </div>
            <div className="w-[20%] text-right">{x?.totalQuantity}</div>
          </div>
        ))}
      </div>
    </div>
  )
}